(function() {


  zfrespond.views.EditMediaResponseView = Backbone.View.extend({

    className: 'edit-media-response-view',

    events: {
      "click .action-submit": "handleSubmit"
    },

    template: ZFRESPOND_JST['respond.edit_media_response'],

    initialize: function() {
      var me = this;

      // this.model.trigger('edit:start', this);
      
      // asset precursor is undefined for recorded responses
      this.assetPrecursor = this.model.assetPrecursor;

      this.thumbnailSrc = '';

      if (this.assetPrecursor && this.assetPrecursor.canMakeThumbnail()) {
        this.assetPrecursor.thumbnailReady.done(function(src) {
          me.thumbnailSrc = src;
          me.render();
        });
      }

    },

    focus: function() {
      // noop
    },

    remove: function() {
      this.model.trigger('edit:end', this);
      zfrespond.views.EditMediaResponseView.__super__.remove.call(this);
    },

    render: function() {

      var attrs = _.extend({
        thumbnailSrc: this.thumbnailSrc

      }, this.model.attributes);

      this.$el.html(this.template(attrs));

      return this;
    },

    handleSubmit: function() {
      var me = this;
      var $submitBtn = $('.save-button');
      var newAttrs = {};
      // var assetTitle = $.trim(this.$('[name="title"]').val());
      var assetCaption = $.trim(this.$('[name="caption"]').val());

      if (assetCaption) {
        newAttrs.asset_caption = assetCaption;
      }
      // Blargh... PATCH means we need to ensure this gets saved
      newAttrs.media_collector_id = this.model.get('media_collector_id');

      if (this.model.isNew()) {
        // If this model has yet to be saved that means we haven't 
        // gotten an asset from the assetPrecursor yet...
        // so instead of `save`-ing we `set` the attributes and allow
        // the assetPrecursor response handler to do saving
        this.model.set(newAttrs);
        me.trigger('submit', this.model);

      } else {
        $submitBtn.prop('disable', true);

        this.model.save(newAttrs, { patch:true })

          .done(function() {
            me.trigger('submit', this.model);
          })

          .always(function() {
            $submitBtn.prop('disable', false);
          });
      }
    }
  });


  zfrespond.views.EditMediaResponseFullpageView = zfrespond.views.EditMediaResponseView.extend({
    
    events: {
      "click .action-go-back": "handleGoBack",
      "click .action-submit": "handleSubmitFullpage"
    },

    template: ZFRESPOND_JST['respond.edit_media_response_fullpage'],

    className: 'edit-media-response-view edit-media-response-fullpage-view',

    initialize: function() {
      this.thumbnail = new zfrespond.views.MediaResponseThumbnailView({
        model: this.model,
        clickTriggersEdit: false
      });
      // zfrespond.views.EditMediaResponseFullpageView.__super__.initialize.call(this);
    },

    render: function() {
      this.$el.html(this.template(this.model.attributes));
      this.$('.thumbnail-container').append(this.thumbnail.render().$el);
      return this;
    },

    handleSubmitFullpage: function() {
      this.handleSubmit();
      // NOTE! We exit before asset is really successfully submitted!
      this.trigger('exit'); 
    },

    handleGoBack: function() {
      this.trigger('exit');
    }

  });


}());